class PageNav {

    constructor() {
        $(document).on('click', '.js-append-elements, .js-replace-elements', (e) => {
            this.load(e)
        })
    }

    load(e) {
        console.log(e)
        let root = $(e.currentTarget).parents('.load-more-root'),
            elementContainerSelector = root.data('elements'),
            mobElementContainerSelector = root.data('mob-elements'),
            paginationContainerSelector = root.data('pagination'),
            targetElementContainer = $(elementContainerSelector),
            targetMobElementContainer = $(mobElementContainerSelector),
            targetPaginationContainer = $(paginationContainerSelector),
            url = $(e.currentTarget).data('href'),
            replace = $(e.currentTarget).hasClass('js-replace-elements');

        if (typeof url !== "undefined" && typeof targetPaginationContainer !== "undefined" && typeof targetElementContainer !== "undefined") {
            e.preventDefault();
            $(e.currentTarget).remove();
            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'html',
                success: function (data) {
                    let elements = $(data).find(elementContainerSelector),
                        elementsMob = $(data).find(mobElementContainerSelector),
                        pagination = $(data).find(paginationContainerSelector);

                    if (replace) {
                        console.log(replace)
                        targetElementContainer.html(elements.children() as any);
                    } else {
                        targetElementContainer.append(elements.children());
                    }

                    if (targetMobElementContainer.length > 0) {
                        if (replace) {
                            targetMobElementContainer.html(elementsMob.children() as any);
                        } else {
                            targetMobElementContainer.append(elementsMob.children());
                        }
                    }

                    targetPaginationContainer.html(pagination.html());
                }
            })
        }
    }

}

export default PageNav;
